import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { composeValidators, mustBeCurrency, required } from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';

interface ContractEquipmentFormProps {
  onSubmit: any;
  equipments: Option[];
}

function ContractEquipmentForm({ onSubmit, equipments }: ContractEquipmentFormProps) {
  const { t } = useTranslation();

  return (
    <div>
      <EnhancedForm
        title={t('entities.contract.tab-equipment.title')}
        subtitle={t('entities.contract.tab-equipment.subtitle')}
        onSubmit={onSubmit}
        formId="addEquipment"
        hideControls={false}
        autoStyleLayout={true}
        density="compact">
        <IdentityField
          gridSpan={3}
          name="equipment"
          component={AutocompleteAdapter}
          options={equipments}
          label={t('global.equipment')}
          type="text"
        />
        <IdentityField
          gridSpan={2}
          name="invoice_frequency"
          label={t(`entities.contract.invoice_frequency`)}
          component={AutocompleteAdapter}
          options={[
            {
              id: 'MONTHLY',
              code: t('entities.contract.invoice_frequency_options.MONTHLY')
            },
            {
              id: 'QUARTERLY',
              code: t('entities.contract.invoice_frequency_options.QUARTERLY')
            },
            {
              id: 'YEARLY',
              code: t('entities.contract.invoice_frequency_options.YEARLY')
            }
          ]}
          type="text"
          validate={composeValidators(required)}
        />
        <IdentityField
          name="yearly_lease_amount"
          label={t('entities.contract-equipment.yearly_lease_amount')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(mustBeCurrency)}
          tooltip={
            'Canone annuo previsto se lo strumento è in noleggio o leasing. Alternativo alla Quota acquisto capitale.'
          }
        />
        <IdentityField
          name="purchase_amount"
          label={t('entities.contract-equipment.purchase_amount')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(mustBeCurrency)}
          tooltip={
            'Costo di acquisizione una tantum se lo strumento viene acquistato. Alternativo alla Quota noleggio annuale.'
          }
        />
        <IdentityField
          name="depreciation_years"
          label={t('entities.contract-equipment.depreciation_years')}
          component={TextFieldAdapter}
          type="number"
          tooltip={
            'Periodo di ammortamento fiscale espresso in anni. Compilare solo in caso di acquisto.'
          }
        />
        <IdentityField
          gridSpan={2}
          name="yearly_maintenance_amount"
          label={t('entities.contract-equipment.yearly_maintenance_amount')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(mustBeCurrency, required)}
        />
      </EnhancedForm>
    </div>
  );
}

export default ContractEquipmentForm;
